'use strict'
var ads = angular.module('adsModule',[
	'ui.router',
	'servicesModule',
	'ngResource'
]);
require('./bannerSlider/js/bannerSliderController.js')(ads);
require('./bannerSlider/js/directive/bannerSliderDirective.js')(ads);
require('./adsTxt/js/adsTxtController.js')(ads);
require('./adsTxt/js/directive/adsTxtDirective.js')(ads);
require('./settings/js/adsSettingsController.js')(ads);
require('./settings/js/directive/adsSettingsDirective.js')(ads);
require('./settings/js/directive/adsCategoryAccordionDirective.js')(ads);
require('./settings/js/directive/adItemDirective.js')(ads);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/adsModule.js
// module id = 476
// module chunks = 0